import { Avatar, HStack, Icon, SuitabilityBadge, Text, VStack } from '@genial/components';
import React from 'react';

import { InfoPanelTypes } from '..';
import { MultipleAccountsSelection } from '../../../../../../components/MultipleAccountsSelection';
import { BlockStatusTooltip } from '../components/BlockStatusTooltip';

export const InfoPanelVisibleTablet: React.FC<InfoPanelTypes.Props> = ({
  isLoading,
  customer,
  accountSelected,
  handleChangeAccount,
}) => {
  return (
    <HStack space="stack.xxxs" width="full" alignItems="center" justifyContent="space-between">
      <HStack space="stack.nano" width="50%" alignItems="center">
        {!isLoading && customer ? (
          <SuitabilityBadge
            label={customer.investorProfile.suitabilityNormalized}
            hideText
            withTooltip
          />
        ) : (
          <Avatar
            testId="avatar"
            isLoading
            bgColor="backgroundlight"
            initials="LO"
            textColor="background"
          />
        )}
        <VStack space="stack.quarck" flex={1}>
          <Text
            isLoading={isLoading}
            variant="bold"
            flex={1}
            ellipsizeMode="tail"
            numberOfLines={1}>
            {customer?.personalInformation.fullNameNormalized}
          </Text>
          <Text isLoading={isLoading}>{customer?.personalInformation.emailNormalized}</Text>
        </VStack>
      </HStack>
      <HStack space="stack.xxxs">
        <VStack space="stack.quarck">
          <Text variant="semibold">Conta de custódia</Text>
          {customer && !isLoading ? (
            <MultipleAccountsSelection
              accounts={customer.additionalAccounts}
              accountSelected={accountSelected}
              setAccountSelected={handleChangeAccount}
            />
          ) : (
            <Text isLoading flex={1} minW="80px" />
          )}
        </VStack>
        <VStack space="stack.quarck">
          <Text variant="semibold">Cadastro</Text>
          <BlockStatusTooltip customer={customer} isLoading={isLoading}>
            <HStack alignItems="center" space="stack.quarck">
              <Text isLoading={isLoading} w={isLoading ? 'full' : undefined}>
                {customer?.accountAndEarnings.statusNormalized.textNormalized}
              </Text>
              {!isLoading && customer && (
                <Icon
                  testID="account-status-icon"
                  name={customer?.accountAndEarnings.statusNormalized.iconNormalized}
                  size={customer?.accountAndEarnings.statusNormalized.iconSizeNormalized}
                  color={customer?.accountAndEarnings.statusNormalized.iconColorNormalized}
                />
              )}
            </HStack>
          </BlockStatusTooltip>
        </VStack>
      </HStack>
    </HStack>
  );
};
